// MUI
import { GridColDef } from "@mui/x-data-grid-pro";
import { useGridApiRef } from "@mui/x-data-grid-premium";
// Third Party
import moment from "moment";

// Hooks
import useSummaryTransformedRows from "@DataPages/hooks/inventory/reconciliation/useSummaryTransformedRows";

// Components
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import TypographyCell from "@Layouts/components/Tables/DataSmartTable/additional/TypographyCell";

// Types
import { ISummaryDetail } from "@DataPages/types/inventory/models/reconciliation";
import { TReconciliationSummaryPropertyRow } from "@DataPages/types/inventory/commons";
import { propertiesMap } from "@DataPages/components/Inventory/Tables/Reconciliation/SummaryTable/constants";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

type BasicInformationSummaryDetail = Pick<ISummaryDetail, "storeNumber" | "inventoryDate" | "reconciliationCompletionDate" | "dealership">;
type BasicInformationTableProps = Readonly<{
	data: BasicInformationSummaryDetail;
}>;
const propertyRows: TReconciliationSummaryPropertyRow<BasicInformationSummaryDetail>[] = [
	{
		label: "storeNumber",
		idx: 0,
	},
	{
		label: "inventoryDate",
		idx: 1,
	},
	{
		label: "reconciliationCompletionDate",
		idx: 2,
	},
	{
		label: "dealership",
		idx: 3,
	},
];

const columns: GridColDef[] = [
	{
		field: "_id",
		headerName: "",
	},
	{
		field: "key",
		headerName: "",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			return <TypographyCell params={params} fontWeight={"700"} />;
		},
	},
	{
		field: "value",
		headerName: "",
		flex: 1,
		align: "right",
		type: "number",
		sortable: false,
		renderCell: (params) => {
			if (params.row?.key === propertiesMap["inventoryDate"] || params.row?.key === propertiesMap["reconciliationCompletionDate"]) {
				return (
					<TypographyCell params={params}>
						{moment(params.row.value).isValid() ? moment(params.row.value).format(DATE_FORMAT.usDateTime12hPadded) : "-"}
					</TypographyCell>
				);
			}
			return <TypographyCell params={params} />;
		},
	},
];

export default function BasicInformationTable(props: BasicInformationTableProps) {
	const apiRef = useGridApiRef();

	const basicSummaryTableTransformedRows = useSummaryTransformedRows({
		propertyRows,
		data: props.data,
	});

	return (
		<DataSmartTable
			apiRef={apiRef}
			rowHeight={25}
			headerHeight={20}
			rows={basicSummaryTableTransformedRows}
			columns={columns}
			disableColumnMenu
			disableRowSelectionOnClick
			aggregationModel={{
				value: "exclusiveSummation",
			}}
			columnVisibilityModel={{
				_id: false,
			}}
			customProps={{
				tableClassName: {
					"functional-table footer-table-included": true,
					"mb-[-10px]": true,
				},
			}}
		/>
	);
}
